import { render, staticRenderFns } from "./QuoteInsurer.vue?vue&type=template&id=568e2544&scoped=true"
import script from "./QuoteInsurer.vue?vue&type=script&lang=js"
export * from "./QuoteInsurer.vue?vue&type=script&lang=js"
import style0 from "./QuoteInsurer.vue?vue&type=style&index=0&id=568e2544&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568e2544",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('568e2544')) {
      api.createRecord('568e2544', component.options)
    } else {
      api.reload('568e2544', component.options)
    }
    module.hot.accept("./QuoteInsurer.vue?vue&type=template&id=568e2544&scoped=true", function () {
      api.rerender('568e2544', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/QuoteHeader/QuoteInsurer.vue"
export default component.exports